import m from "../../es2015/lang/ko_KR";
window.am4lang_ko_KR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ko_KR.js
// module id = null
// module chunks = 